// extracted by css-extract-rspack-plugin
export default {"viewMore":"_b0fe49e5","large":"_10b19620","regular":"_a75f0e47","larger":"_1a3ba312","heavy":"_e8ed5f5e"};